import { AfterViewInit, Component, HostListener, inject, Injector, viewChild } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { AccessService } from "@core/client/access.service";
import { CompanyModulesService } from "@core/client/company-modules.service";
import { CompanyService } from "@core/client/company.service";
import { LocaleService } from "@core/client/locale.service";
import { OrganisationService } from "@core/client/organisation.service";
import { UserService } from "@core/client/user.service";
import { ErrorService } from "@core/common/error.service";
import { LoadingAlertService } from "@core/common/loading-alert.service";
import { FeatureFlagsService } from "@core/feature-flags/page-feature-flags.service";
import { NavigationBarToggleComponent } from "@core/navigation/components/navigation-bar-toggle/navigation-bar-toggle.component";
import { NavigationBarComponent } from "@core/navigation/components/navigation-bar/navigation-bar.component";
import { NavigationDrawerComponent } from "@core/navigation/components/navigation-drawer/navigation-drawer.component";
import { NavigationService } from "@core/navigation/navigation.service";
import { NotificationsService } from "@core/notifications/notifications.service";
import { CompanyBarComponent } from "@core/ui/components/company-bar/company-bar.component";
import { FooterToolbarComponent } from "@core/ui/components/footer-toolbar/footer-toolbar.component";
import { StatusBarComponent } from "@core/ui/components/status-bar/status-bar.component";
import { TrademarkComponent } from "@core/ui/components/trademark/trademark.component";
import { UIService } from "@core/ui/ui.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ChangePasswordModalComponent } from "@identity/components/change-password-modal/change-password-modal.component";
import { LoginModalComponent } from "@identity/components/login-modal/login-modal.component";
import { LoginSessionsModalComponent } from "@identity/components/login-sessions-modal/login-sessions-modal.component";
import { FontAwesomeService } from '@oi-soft/icons';
import { LoadingScreenComponent } from "@shared/components/loading/loading-screen/loading-screen.component";
import { GlobalModalsService } from "@shared/services/global-modals.service";
import { VoltaSweetAlertService } from "@shared/services/volta-sweet-alert/volta-sweet-alert.service";
import { AllCommunityModule, ClientSideRowModelModule, ModuleRegistry } from 'ag-grid-community';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, StatusBarComponent, TrademarkComponent, NavigationBarComponent, NavigationBarToggleComponent, LoadingScreenComponent, CompanyBarComponent, LoginModalComponent, FooterToolbarComponent, LoginSessionsModalComponent, FontAwesomeModule, NavigationDrawerComponent, ChangePasswordModalComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit{

    tableModule = ModuleRegistry.registerModules([
        ClientSideRowModelModule,
        AllCommunityModule
    ]);

    injector = inject(Injector);

    organisationService = inject(OrganisationService);
    companyService = inject(CompanyService);
    localeService = inject(LocaleService);
    modulesService = inject(CompanyModulesService);
    accessService = inject(AccessService);
    featureFlagsService = inject(FeatureFlagsService);
    userService = inject(UserService);
    uiService = inject(UIService);
    navigationService = inject(NavigationService);
    swalService = inject(VoltaSweetAlertService);
    faService = inject(FontAwesomeService);
    globalModalsService = inject(GlobalModalsService);
    notificationsService = inject(NotificationsService);
    errorService = inject(ErrorService);
    loadingAlertService = inject(LoadingAlertService);
    
    loginModal = viewChild(LoginModalComponent);
    sessionsModal = viewChild(LoginSessionsModalComponent);
    changePasswordModal = viewChild(ChangePasswordModalComponent);
    
    ngAfterViewInit(): void {
        this.globalModalsService.loginModal.set(this.loginModal());
        this.globalModalsService.sessionsModal.set(this.sessionsModal());
        this.globalModalsService.changePasswordModal.set(this.changePasswordModal());
    }
    
    @HostListener('window:resize')
    onResize() {
        this.uiService.updateWindowSize();
    }
}
